<template>

  <vx-card :subtitle="subjectCompute.nameLocal"
           :title="subjectCompute.code"
           class="mb-base"
           subtitle-color="warning"
           title-color="primary"
  >
    <template slot="actions">
      <div class="flex justify-end mb-4">
        <vs-chip class="pr-0" color="primary" transparent>
          <span>{{ $t('course-outline-registration.academic-period-short') }}</span>
          <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">{{ courseOutlineRegistrationCompute.periodCode}}
          </vs-chip>
        </vs-chip>

        <vs-chip class="pr-0" color="primary" transparent>
          <span>{{ $t('class-over-view.section-short') }}</span>
          <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">{{ classSectionCompute.sectionNo }}
          </vs-chip>
        </vs-chip>

        <vs-chip class="pr-0" color="primary" transparent>
          <span>{{ $t('class-over-view.learn-span-no-short') }}</span>
          <vs-chip class="bg-primary ml-2 mb-0 text-white font-semibold">{{ classSectionCompute.learnSpanNo }}
          </vs-chip>
        </vs-chip>
      </div>
    </template>

    <p>{{ subjectCompute.description }}</p>
  </vx-card>

</template>

<script>

  export default {
    props: {
      classRoom: Object,
    },
    computed:{
      subjectCompute(){
        return this.classRoom ? this.classRoom.subject:{}
      },
      classSectionCompute(){
        return this.classRoom ? this.classRoom.classSection:{}
      },
      courseOutlineRegistrationCompute(){
        return this.classRoom ? this.classRoom.courseOutlineRegistration:{}
      },
    }
  }
</script>

<style scoped>

</style>
